import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Button extends Component {
    render() {
        const { text, className, onClick, type, size, disabled, dataTest, marginLeft, marginRight, isButtonWidthIsAuto, customWidth,  } = this.props;
        return (
            <button
                onClick={ onClick }
                className={classnames({
                    [`btn ${className} ${type} ${size}`]: true,
                    'width-auto': isButtonWidthIsAuto && !customWidth,
                })}
                disabled={disabled}
                data-test={dataTest ? dataTest : 'button'}
                style={Object.assign({}, customWidth && {width: customWidth + 'px'}, {marginLeft, marginRight})}
            >
                { text }
            </button>
        )
    }
}

Button.defaultProps = {
    className: '',
    disabled: false,
    onClick: () => {},
    type: 'b2c-primary',
    size: 'medium',
    text: '',
    dataTest: '',
};

Button.propTypes = {
    type: PropTypes.oneOf(['b2c-primary', 'b2b-primary', 'orange', 'destructive', 'secondary', 'outline', 'white', 'outline-white']),
    size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    marginLeft: PropTypes.string,
    marginRight: PropTypes.string,
    isButtonWidthIsAuto: PropTypes.bool,
    customWidth: PropTypes.string,
    dataTest: PropTypes.string,
};
